import * as React from 'react';
import { useEffect } from 'react';
import CommonCard from './CommonCard';
import { getOrderStatus, getTravellers } from '../../../../Checkout/store/order/selectors';
import { useSelector } from 'react-redux';
import { OrderStatus } from '@websky/graphql';
import { isServicesSaving } from '../../../../Checkout/store/servicesIsSaving/selectors';
import { useToggleable } from '../../../../hooks';
import Dialog from '../../../../Service/components/Dialog/Dialog';
import Inner from '../Inner/Inner';
import Rules from '../Rules/Rules';
import { useEveryPort } from '../everyPort.hooks';
import { useMediaQuery } from 'react-responsive';
import { MOBILE_MIN_WIDTH } from '../../../../utils';
import WebskyAnalyticsApollo from '../../../../DataLayerAnalytics/WebskyAnalyticsApollo';
import { WxEvents } from '../../../../DataLayerAnalytics/types';
const WrappedCommonCard = props => {
    var _a, _b;
    const [isRulesOpen, setRulesOpen] = React.useState(false);
    const orderStatus = useSelector(getOrderStatus);
    const isReadonly = orderStatus === OrderStatus.Cancelled;
    const serviceSaving = useSelector(isServicesSaving);
    const travellers = useSelector(getTravellers);
    const { isOpen, open, close } = useToggleable(false);
    const { services, selectedSummary, onServiceSave, availableSegments, selectedServices, priceFrom } = useEveryPort(props.category, props.segmentId, isReadonly);
    useEffect(() => {
        var _a;
        if (!isOpen || !services.length) {
            return;
        }
        if (services.length > 1) {
            WebskyAnalyticsApollo.dispatchWxViewEvent(WxEvents.NASVipList, {
                nasType: (_a = services[0]) === null || _a === void 0 ? void 0 : _a.type,
                servicesIds: services.map(service => service.id)
            });
        }
        else {
            WebskyAnalyticsApollo.dispatchWxViewEvent(WxEvents.NASVipItem, {
                segmentId: props.segmentId,
                servicesIds: [services[0].id]
            });
        }
    }, [isOpen, services]);
    const isMobile = useMediaQuery({ maxWidth: MOBILE_MIN_WIDTH });
    const openDetails = () => {
        var _a;
        if (!!((_a = selectedSummary === null || selectedSummary === void 0 ? void 0 : selectedSummary.rules) === null || _a === void 0 ? void 0 : _a.length)) {
            setRulesOpen(true);
        }
        else if (selectedSummary === null || selectedSummary === void 0 ? void 0 : selectedSummary.detailsLink) {
            window.location.href = selectedSummary.detailsLink;
        }
    };
    const closeDetails = () => setRulesOpen(false);
    return (React.createElement(React.Fragment, null,
        React.createElement(CommonCard, Object.assign({}, props, { serviceSaving: serviceSaving, travellers: travellers, priceFrom: priceFrom, totalPrice: selectedSummary === null || selectedSummary === void 0 ? void 0 : selectedSummary.price, openDetails: openDetails, isSelected: ((_a = selectedSummary.texts) === null || _a === void 0 ? void 0 : _a.length) > 0, selectedServicesText: selectedSummary.texts, selectedServicesPassengerNames: selectedSummary.passengerNames, selectedServicesDetailsLink: selectedSummary.detailsLink, isModifyAvailable: selectedSummary.modifyAvailable, onOpen: open, serviceType: props.service.type })),
        isOpen && (React.createElement(Dialog, { isOpen: isOpen, onClose: close, dialogType: "fullscreen", hideHeader: !isMobile, dialogHeader: props.header, content: React.createElement(Inner, { everyPortServices: services, selectedServices: selectedServices, segments: availableSegments, onServiceSave: onServiceSave, onClose: close, segmentId: props.segmentId, loading: serviceSaving, travellers: travellers, type: props.category, header: props.header, readonly: isReadonly }) })),
        React.createElement(Rules, { rules: (_b = selectedSummary === null || selectedSummary === void 0 ? void 0 : selectedSummary.rules) !== null && _b !== void 0 ? _b : [], open: isRulesOpen, onClose: closeDetails })));
};
export default WrappedCommonCard;
